import React from 'react'
import styled from 'styled-components'
import { H1, H3 } from './core'
//import SkillCardBG from './SkillCardBackground'
import { theme, breakpoints } from '../ui-config'
import UX_1x from '../images/UX-colored.png'
import UX_2x from '../images/UX-colored@2x.png'
import network_1x from '../images/network-colored.png'
import network_2x from '../images/network-colored@2x.png'
import dev_1x from '../images/dev-colored.png'
import dev_2x from '../images/dev-colored@2x.png'

const CARD_GUTTER = 10;
const SMALL_SKILL_CARD_W = 98

const Container = styled.section`
    display: flex;
    flex-wrap: wrap;
    height: 100vh;
    margin: 0 auto;
    max-width: ${breakpoints.large}px;

    @media (max-width: ${breakpoints.large}px) {
        &::after {
            content: '';
            width: 100%;
        }
    }

    @media (max-width: ${breakpoints.small}px) {
        height: unset;
    }
`

const IntroTextContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: ${breakpoints.large}px) {
        margin-top: 18vh;
        text-align: center;
    }
`

const SkillCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: ${breakpoints.large}px) {
        order: 1;
        flex: 1;
        flex-direction: row;
    }
`

const SkillCardsInnerContainer = styled.div`
    display: flex;
`

const StyledSkillCard = styled.div`
    height: 227px;
    width: 140px;
    color: ${theme.coloredHeaders};
    position: relative;
    flex: 1;
    border: 2px solid ${theme.coloredHeaders};
    border-radius: 10px;

    @media (max-width: ${breakpoints.small}px) {
        & {
            margin-top: 20px;
            width: ${SMALL_SKILL_CARD_W}px;
        }
    }
`

const SkillCardContent = styled.div`
    top: 0;
    left: 0;
    display: flex;
    position: absolute;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 20px;

    @media (max-width: ${breakpoints.small}px) {
        padding: 10px;
        font-size: 1.4rem;
    }
`

// "${props => props.icons['2x']}" 2x);
const SkillCardIcon = styled.div`
    background-image: url(${props => props.icons['1x']});
    height: 46px;
    background-repeat: no-repeat;
    background-position: center;
    width: auto;
    margin-bottom: 25px;
    margin-top: 15px;

    @media (max-width: ${breakpoints.small}px) {
        margin-top: 40px;
        margin-bottom: 20px;
    }
`

const SkillCardText = styled.div`
    flex: 1;
`

const SkillCard = (props) => {
    return (
        <StyledSkillCard style={props.style}>
            <SkillCardContent>
                <SkillCardIcon icons={props.icons} />
                <SkillCardText>{ props.text }</SkillCardText>
            </SkillCardContent>
        </StyledSkillCard>
    )
}
//<H3>Launching a new product is complex.<br />Let me help.</H3>
export default function Intro() {
    return (
        <Container>
            <IntroTextContainer>
                <H1>{'Product Design \u0026'}<br />Development</H1>
                <H3>How can I help?</H3>
            </IntroTextContainer>
            <SkillCardsContainer>
                <SkillCardsInnerContainer>
                    <SkillCard
                    text={'Research, strategy \u0026 design'}
                    icons={{ '1x': UX_1x, '2x': UX_2x }}
                    style={{ marginRight: `${CARD_GUTTER}px` }}/>
                    <SkillCard
                    icons={{ '1x': dev_1x, '2x': dev_2x }}
                    text={'Web Development, JavaScript \u0026 Python'}
                    />
                    <SkillCard
                    icons={{ '1x': network_1x, '2x': network_2x }}
                    text={'Data Science \u0026 Data Visualization'}
                    style={{ marginLeft: `${CARD_GUTTER}px` }}
                    />
                </SkillCardsInnerContainer>
            </SkillCardsContainer>
        </Container>
    )
}



// WEBPACK FOOTER //
// ./src/components/Intro.js